import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";

type UserAvatarProps = {
  name: string;
};

export const UserAvatar = ({ name }: UserAvatarProps) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center rounded-circle"
      style={{
        height: "56px",
        width: "56px",
        backgroundColor: colors.ctaLight,
      }}
    >
      <StyledText className="headerThree mb-0" color={colors.ctaMain}>
        {name.substring(0, 1)}
      </StyledText>
    </div>
  );
};
